import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=62d06c80"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62d06c80')) {
      api.createRecord('62d06c80', component.options)
    } else {
      api.reload('62d06c80', component.options)
    }
    module.hot.accept("./NotFound.vue?vue&type=template&id=62d06c80", function () {
      api.rerender('62d06c80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sample/NotFound.vue"
export default component.exports